import { createContext, useContext } from 'react';

type OpenWelcomeModal = () => void;

const WelcomeModalContext = createContext<OpenWelcomeModal | null>(null);

export function WelcomeModalProvider({
  children,
  openWelcomeModal,
}: {
  children: React.ReactNode;
  openWelcomeModal: OpenWelcomeModal;
}) {
  return (
    <WelcomeModalContext.Provider value={openWelcomeModal}>
      {children}
    </WelcomeModalContext.Provider>
  );
}

export function useOpenWelcomeModal(): OpenWelcomeModal {
  const open = useContext(WelcomeModalContext);
  if (!open) throw new Error('useOpenWelcomeModal must be used within WelcomeModalProvider');
  return open;
}
